export const CAM_DOC_MANAGER_MAIN_VIEW_TABLE_ID = 'camDocumentManagerMainView';
export const CAM_DOC_MANAGER_STUDENT_VIEW_TABLE_ID =
  'camDocumentManagerStudentView';
export const CAM_DOC_MANAGER_COLLEGE_VIEW_TABLE_ID =
  'camDocumentManagerCollegeView';
